import {
  faCheckSquare,
  faMinusSquare,
  faSquareParking,
  faTimesSquare,
} from "@fortawesome/pro-duotone-svg-icons";
import { Tooltip } from "@/components/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { tv } from "tailwind-variants";
import stringToTitleCase from "@/utils/stringToTitleCase";

const iconClassName = tv({
  base: "h-20 w-20",
  variants: {
    color: {
      PASS: "text-green",
      FAIL: "text-red",
      WARN: "text-orange",
      SKIPPED: "text-gray-dark",
      PENDING: "text-primary",
    },
  },
});

interface IProps {
  value: IHealthCheckStatus | boolean;
}

const SmsHealthCheckHistoryCell = ({ value }: IProps) => {
  const getIcon = () => {
    if (typeof value === "boolean") {
      return value ? faCheckSquare : faTimesSquare;
    }

    const mapping = {
      PASS: faCheckSquare,
      FAIL: faTimesSquare,
      WARN: faTimesSquare,
      SKIPPED: faMinusSquare,
      PENDING: faSquareParking,
    };

    return mapping[value] || faTimesSquare;
  };

  const getVariant = () => {
    switch (value) {
      case true:
        return "PASS";
      case false:
        return "FAIL";
      case undefined:
        return "FAIL";
      default:
        return value;
    }
  };

  const getTooltipValue = () => {
    if (typeof value === "boolean") return value ? "Pass" : "Fail";
    return value === "PASS" || value === "PENDING" || value === "SKIPPED"
      ? stringToTitleCase(value)
      : "Fail";
  };

  const tooltipContent = getTooltipValue();

  return (
    <Tooltip content={tooltipContent}>
      <FontAwesomeIcon
        icon={getIcon()}
        className={iconClassName({ color: getVariant() })}
        height="22px"
        width="22px"
      />
    </Tooltip>
  );
};

export default SmsHealthCheckHistoryCell;
